import { createAlert } from "../utils/alertUtils";
import API from "./base.service";

export const fetchCustomers = async () => {
  const res = await API.get("/customers");
  return res?.data?.body?.data || [];
};
export const fetchCustomerCompany = async (queryParams = {}) => {
  try {
    const res = await API.get("/customers", {
      params: queryParams, // Pass query params dynamically
    });
    return res;
  } catch (error) {
    console.error("Error fetching customers:", error);
    return []; // Return empty array in case of error
  }
};
export const createCustomer = async (payload) => {
  const isFormData = payload instanceof FormData;
  const res = await API.post("/customers", payload, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : undefined,
  });
  return res?.data;
};

export const updateCustomer = async (customerId, payload) => {
  const isFormData = payload instanceof FormData;
  console.log("isFormData", isFormData);
  const res = await API.put(`/customers/${customerId}`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res?.data;
};
export const uploadCustomerDocuments = async (customerId, payload) => {
  const res = await API.post(`/customers/${customerId}/documents`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res?.data;
};

export const deleteCustomerDocument = async (documentId) => {
  const res = await API.delete(`/customers/documents/${documentId}`);
  return res?.data;
};
export const updateCustomerDocument = async (documentId, payload) => {
  const res = await API.patch(`/customers/documents/${documentId}`, payload);
  return res?.data;
};
export const deleteCustomer = async (customerId) => {
  const res = await API.delete(`/customers/${customerId}`);
  return res?.data;
};
export const createAddress = async (payload) => {
  try {
    const res = await API.post("/addresses", payload);
    if (res.data?.isSuccess) {
      createAlert({
        type: "success",
        status: true,
        notification: {
          title: res?.data?.message || "Success",
          body: res?.data?.message || "Address created successfully",
          titleArabic: res?.data?.message || "نجاح",
          bodyArabic: res?.data?.message || "تم إنشاء العنوان بنجاح",
        },
      });
    } else {
      createAlert({
        type: "error",
        status: true,
        notification: {
          title: res?.data?.message || "Error",
          body: res?.data?.message || "Address created successfully",
          titleArabic: res?.data?.message || "نجاح",
          bodyArabic: res?.data?.message || "تم إنشاء العنوان بنجاح",
        },
      });
    }
    return res.data?.body;
  } catch (error) {}
};

export const fetchBranch = async (company_id) => {
  const res = await API.get("/branches", { params: { company_id } });
  return res?.data?.body?.data || [];
};

export const createBranch = async (payload) => {
  try {
    const res = await API.post("/branches", payload);

    if (res.data?.isSuccess) {
      createAlert({
        type: "success",
        status: true,
        notification: {
          title: res?.data?.message || "Success",
          body: res?.data?.message || "Branch created successfully",
          titleArabic: res?.data?.message || "نجاح",
          bodyArabic: res?.data?.message || "تم إنشاء العنوان بنجاح",
        },
      });
    } else {
      createAlert({
        type: "error",
        status: true,
        notification: {
          title: res.data.message || "Error",
          body: res.data.message || "error in creating branch",
          titleArabic: res.data.message || "نجاح",
          bodyArabic: res.data.message || "تم إنشاء العنوان بنجاح",
        },
      });
    }

    return res.data?.body;
  } catch (error) {
    createAlert({
      type: "error",
      status: true,
      notification: {
        title: error?.message || "Error",
        body: error?.message || "error in creating branch",
        titleArabic: error?.message || "نجاح",
        bodyArabic: error?.message || "تم إنشاء العنوان بنجاح",
      },
    });

    return error;
  }
};
export const createOrder = async (payload) => {
  try {
    const res = await API.post("/orders", payload);
    return res;
  } catch (error) {
    return error;
  }
};

export const getCustomerByIdApi = async (customerId) => {
  try {
    const res = await API.get(`/customers/${customerId}`);
    return res;
  } catch (error) {
    console.error("Error fetching customer:", error);
    throw error;
  }
};

export const getOrdersByCustomerIdApi = async (customerId, params = {}) => {
  try {
    const res = await API.get("/orders", {
      params: { customer_id: customerId, ...params },
    });
    return res;
  } catch (error) {
    console.error("Error fetching customer orders:", error);
    throw error;
  }
};
